import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { forwardRef, useEffect, useState } from "react";
import { InputProps } from "./inputProps";

const Input = forwardRef<HTMLInputElement, InputProps>(({
    error,
    placeholder,
    value = '',
    type = "text",
    width = 300,
    height = 55,
    onChange,
    onBlur,
    name,
    disabled = false,
    required = false,
    icon = false,
    mask,
    ...rest
  }, ref) => {

    const [inputValue, setInputValue] = useState(value as string);
    
    useEffect(() => {
      setInputValue(value as string);
    }, [value]);
    
    const applyMask = (value: string, mask?: string) => {
      if (!mask) return value;
      
      const onlyNumbers = value.replace(/\D/g, '');
      let result = '';
      let numberIndex = 0;
      
      for (let i = 0; i < mask.length; i++) {
        if (numberIndex >= onlyNumbers.length) break;
        
        const maskChar = mask[i];
        
        if (maskChar === '9') {
          result += onlyNumbers[numberIndex++];
        } else {
          result += maskChar;
          
          if (onlyNumbers[numberIndex] === maskChar) {
            numberIndex++;
          }
        }
      }
      
      return result;
    };
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      
      if (mask) {
        const maskedValue = applyMask(newValue, mask);
        setInputValue(maskedValue);
        
        if (onChange) {
          const syntheticEvent = {
            ...e,
            target: {
              ...e.target,
              value: maskedValue
            }
          };
          onChange(syntheticEvent);
        }
      } else {
        setInputValue(newValue);
        onChange?.(e);
      }
    };

    // Estilos comuns para TextField
    const textFieldStyle = {
      display: 'flex',
      alignItems: 'flex-end',
      width: "100%",
      height: height,
      backgroundColor: "#fff",
      "& .MuiInputBase-root": {
        height: "100%",
      },
    };

    return (
      <Box sx={{ width: width }}>
        <TextField
          inputRef={ref}
          label={placeholder}
          placeholder={placeholder}
          name={name}
          value={inputValue}
          onChange={handleChange}
          onBlur={onBlur}
          error={!!error}
          disabled={disabled}
          required={required}
          type={type}
          variant="outlined"
          fullWidth
          className={`container-input__input ${error ? "container-input__input__error" : "container-input__input__default"}`}
          sx={textFieldStyle}
          {...rest}
        />
        {error && (<span className="container-input__input__error-message">{error.toString()}</span>)}
      </Box>
    );
  }
);

export default Input;